import type {
  NavigationGuard,
  RouteLocationNormalizedGeneric,
  RouteLocationRaw,
} from "vue-router";

export type AccessMap = {
  guest: boolean;
  authenticated: boolean;
};

type Options = {
  allowAccess: AccessMap;
  isAuthenticated: () => boolean;
  getRedirect: (
    authenticated: boolean,
    to: RouteLocationNormalizedGeneric,
    from: RouteLocationNormalizedGeneric,
  ) => RouteLocationRaw;
};

export const createAuthGuard = (options: Options): NavigationGuard => {
  const { getRedirect, isAuthenticated } = options;

  return (to, from) => {
    const allowAccess = {
      ...options.allowAccess,
      ...to.meta.allowAccess,
    };

    const authenticated = isAuthenticated();
    const accessAllowed = authenticated
      ? allowAccess.authenticated
      : allowAccess.guest;

    if (!accessAllowed) {
      return getRedirect(authenticated, to, from);
    }
  };
};
